import { BrandBgEntity } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandBgCreateResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandBgCreateResponseDTO.validationSchema(),
    BrandBgEntity
  );

  constructor(readonly data: RoomBrandBgCreateResponse) {
    JsonSchemaValidator.assert(RoomBrandBgCreateResponseDTO.validation, data);
  }

  toJSON() {
    return this.data;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  private static validationSchema() {
    return {
      type: "object",
      required: ["brandBg"],
      properties: {
        brandBg: {
          instanceof: BrandBgEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandBgCreateResponse {
  brandBg: BrandBgEntity;
}
